/**
 * Bilingual invite codes.
 *
 * Codes are stored in Latin (alphabet ABCDEFGHJKLMNPQRSTUVWXYZ23456789).
 * Each code has a Cyrillic twin via the 1:1 mapping below so players on a
 * Russian keyboard can type either version — both resolve to the same game.
 * Digits are shared. Keep in sync with backend/app/services/code_alias.py.
 */

const LAT = "ABCDEFGHJKLMNPQRSTUVWXYZ";
const CYR = "АБЦДЕФГХЙКЛМНПЩРСТУВШЖЫЗ";

const cyrToLat = new Map([...CYR].map((c, i) => [c, LAT[i]]));
const latToCyr = new Map([...LAT].map((c, i) => [c, CYR[i]]));

/** Canonical (Latin, uppercase) form of a code typed in either alphabet. */
export function normalizeCode(input: string): string {
  return [...input.trim().toUpperCase()]
    .map((c) => cyrToLat.get(c) ?? c)
    .join("");
}

/** The Cyrillic twin of a canonical Latin code (for display). */
export function cyrillicCode(code: string): string {
  return [...code.trim().toUpperCase()]
    .map((c) => latToCyr.get(c) ?? c)
    .join("");
}
